import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type CreateVoucherCompanyData} from './create-voucher-company';

export function createVoucherCompanyPatcher(
    data: CreateVoucherCompanyData,
): RestTypeWithTypename<CreateVoucherCompanyData> {
    return {
        __typename: 'CreateVoucherCompanyData',
        billPayer: {
            __typename: 'CreateVoucherCompanyBillPayer',
            ...data.billPayer,
        },
    };
}
